const transientStatuses = new Set([429, 500, 502, 503, 504])
const transientCodes = new Set([
  'ECONNRESET', 'ECONNREFUSED', 'ETIMEDOUT', 'EAI_AGAIN',
  'UND_ERR_SOCKET', 'UND_ERR_CONNECT_TIMEOUT', 'UND_ERR_HEADERS_TIMEOUT',
  'UND_ERR_BODY_TIMEOUT'
])

function transientFailure(error) {
  if (transientStatuses.has(error?.status)) return true
  for (let cause = error, depth = 0; cause && depth < 5; cause = cause.cause, depth++) {
    if (transientCodes.has(cause.code)) return true
  }
  // Node fetch can lose the low-level code when a response body is interrupted.
  return error instanceof TypeError && ['fetch failed', 'terminated'].includes(error.message)
}

/**
 * Retry the complete read, including response.json(): sockets can reset after headers arrive.
 * GraphQL mutations, schema errors and successful empty results must never be retried here.
 * @template T
 * @param {string} query
 * @param {() => Promise<T>} request
 * @param {{wait?: (ms: number) => Promise<void>}} options
 * @returns {Promise<T>}
 */
export async function withCmsReadRetry(query, request, { wait = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) {
  const operation = query.replace(/^(?:\s|#[^\n]*(?:\n|$))*/, '')
  const readOnly = /^(?:query\b|\{)/.test(operation)
  for (let attempt = 0; ; attempt++) {
    try {
      return await request()
    } catch (error) {
      if (!readOnly || attempt >= 2 || !transientFailure(error)) throw error
      await wait(500 * 2 ** attempt)
    }
  }
}
